import { CommonModule } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { OpportunityStatusAvailableDto } from '@api-proxies';
import { TooltipDirective } from 'ngx-lib';
import { OpportunityStatusIndicatorConfig } from '../opportunity-status-indicator.component';

@Component({
    selector: 'app-opportunity-bid-status-menu',
    standalone: true,
    templateUrl: './opportunity-bid-status-menu.component.html',
    styleUrls: ['./opportunity-bid-status-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, TooltipDirective]
})
export class OpportunityBidStatusMenuComponent {
    config = input.required<OpportunityStatusIndicatorConfig>();

    statusSelected = output<OpportunityStatusAvailableDto>();

    onSelect(status: OpportunityStatusAvailableDto, event: Event): void {
        event.stopPropagation();
        this.statusSelected.emit(status);
    }
}
